import { Component } from "@angular/core"

@Component({
	selector: "app-services-menu",
	templateUrl: "./services-menu.component.html",
	styleUrls: ["./services-menu.component.scss"]
})
export class ServicesMenuComponent {
	constructor() {}
}
